<template>
    <input
        :id="name"
        :value="value"
        :name="name"
        :placeholder="placeholder"
        :type="type"
        :class="valid === false ? 'invalid' : ''"
        :autocomplete="autocomplete"
        :inputmode="inputmode"
        @input="onInput"
        @change="$emit('change')"
        @click="$emit('click')"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
</template>

<script>
import Page from '../../../../../../resources/frontend/js/mixins/page.vue';
import Mask from '../../../../js/vue-flows/default-components/sb-mask/v2/Mask.vue';

export default {
    mixins: [Page, Mask],

    props: {
        name: {
            type: String,
            required: false,
            default: '',
        },

        type: {
            type: String,
            required: false,
            default: 'text',
        },

        mask: {
            type: String,
            required: false,
            default: '',
        },

        placeholder: {
            type: String,
            required: false,
            default: '',
        },

        value: {
            type: String,
            required: true,
        },

        change: {
            type: Function,
            required: false,
            default: () => {},
        },

        click: {
            type: Function,
            required: false,
            default: () => {},
        },

        blur: {
            type: Function,
            required: false,
            default: () => {},
        },

        valid: {
            type: Boolean,
            required: false,
            default: true,
        },

        autocomplete: {
            type: String,
            required: false,
            default: null,
        },

        inputmode: {
            type: String,
            required: false,
            default: null,
        }
    },

    mounted() {
        this.$emit('init');
    },

    methods: {
        onInput(event) {
            const input = event.target;
            let value = input.value;

            if(this.mask) {
                value = this.useMask('', input, '', this.mask);
            }

            input.value = value;
            this.$emit('set', value);
        },
    },
};
</script>
